import { render, staticRenderFns } from "./gridinitialization.vue?vue&type=template&id=09328728&"
import script from "./gridinitialization.vue?vue&type=script&lang=js&"
export * from "./gridinitialization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports